import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { Checkbox } from "../ui/checkbox";
import { ScrollArea } from "../ui/scroll-area";
import {
  Plus, Clock, Bell, CheckCircle2, Circle,
  Calendar as CalendarIcon, ListTodo, Trash2, Edit
} from "lucide-react";

export function DayEventsDialog({ dialog, setDialog, onOpenReminder, onDeleteReminder, onToggleComplete }) {
  const { open, date, events } = dialog;

  return (
    <Dialog open={open} onOpenChange={(o) => setDialog({ ...dialog, open: o })}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center justify-between">
            <span>{date?.toLocaleDateString("it-IT", { weekday: 'long', day: 'numeric', month: 'long' })}</span>
            <Button size="sm" variant="outline" onClick={() => onOpenReminder(null, date?.toISOString().split('T')[0])}>
              <Plus className="h-4 w-4 mr-1" /> Promemoria
            </Button>
          </DialogTitle>
        </DialogHeader>
        <ScrollArea className="max-h-[400px]">
          {events?.total === 0 ? (
            <div className="text-center py-8 text-muted-foreground">
              <CalendarIcon className="h-12 w-12 mx-auto mb-2 opacity-30" />
              <p>Nessun evento per questo giorno</p>
            </div>
          ) : (
            <div className="space-y-4">
              {events?.attivita?.length > 0 && (
                <div>
                  <h4 className="text-sm font-medium mb-2 flex items-center gap-2">
                    <ListTodo className="h-4 w-4" />Scadenze Attività
                  </h4>
                  <div className="space-y-2">
                    {events.attivita.map(event => (
                      <div key={event.id} className={`p-3 rounded-lg border-l-4 bg-muted/30 ${event.priorita === 'alta' ? 'border-l-red-500' : event.priorita === 'media' ? 'border-l-yellow-500' : 'border-l-green-500'}`}>
                        <div className="flex items-center justify-between">
                          <span className="font-medium">{event.titolo}</span>
                          <Badge variant={event.stato === 'completato' ? 'secondary' : 'outline'}>{event.stato}</Badge>
                        </div>
                        {event.descrizione && <p className="text-sm text-muted-foreground mt-1">{event.descrizione}</p>}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {events?.steps?.length > 0 && (
                <div>
                  <h4 className="text-sm font-medium mb-2 flex items-center gap-2">
                    <CheckCircle2 className="h-4 w-4" />Scadenze Step
                  </h4>
                  <div className="space-y-2">
                    {events.steps.map(event => (
                      <div key={event.id} className="p-3 rounded-lg bg-muted/30">
                        <div className="flex items-center gap-2">
                          {event.completato ? <CheckCircle2 className="h-4 w-4 text-green-500" /> : <Circle className="h-4 w-4 text-muted-foreground" />}
                          <span className={event.completato ? 'line-through text-muted-foreground' : ''}>{event.titolo}</span>
                        </div>
                        <p className="text-xs text-muted-foreground mt-1">Attività: {event.progetto_titolo}</p>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {events?.promemoria?.length > 0 && (
                <div>
                  <h4 className="text-sm font-medium mb-2 flex items-center gap-2">
                    <Bell className="h-4 w-4" />Promemoria
                  </h4>
                  <div className="space-y-2">
                    {events.promemoria.map(event => (
                      <div key={event.id} className="p-3 rounded-lg border-l-4 bg-muted/30 group" style={{ borderLeftColor: event.colore }}>
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-2">
                            <Checkbox checked={event.completato} onCheckedChange={() => onToggleComplete(event)} />
                            <span className={event.completato ? 'line-through text-muted-foreground' : 'font-medium'}>{event.titolo}</span>
                            {event.ora && <Badge variant="outline" className="text-xs"><Clock className="h-3 w-3 mr-1" />{event.ora}</Badge>}
                          </div>
                          <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100">
                            <Button variant="ghost" size="icon" className="h-7 w-7" onClick={() => onOpenReminder(event)}><Edit className="h-3 w-3" /></Button>
                            <Button variant="ghost" size="icon" className="h-7 w-7 text-red-500" onClick={() => onDeleteReminder(event.id)}><Trash2 className="h-3 w-3" /></Button>
                          </div>
                        </div>
                        {event.descrizione && <p className="text-sm text-muted-foreground mt-1 ml-6">{event.descrizione}</p>}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}
